module.exports = __webpack_public_path__ + "static/media/Lake-Village-II-Exhibit-A-Bylaws.d0ad0f1b.pdf";